const CLIENT_TAB_ID_STORAGE_KEY = 'clientTabId'

export const getClientTabId = (): string => {
  const existingTabId = sessionStorage.getItem(CLIENT_TAB_ID_STORAGE_KEY)

  if (existingTabId) {
    return existingTabId
  }

  const newTabId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
  sessionStorage.setItem(CLIENT_TAB_ID_STORAGE_KEY, newTabId)

  return newTabId
}
